import { JSONRpcClient, sbm } from './sbmConfig';

const SBM = {
    client: {}
}
let token = null;
const companyLogin = 'cyno';
const sbmApiKey = sbm.apiKey;

const getToken = () => {
    const loginClient = getLoginClient();
    // console.log('GOT LOGIN CLIENT', loginClient);
    // console.log('GETTING TOKEN...')
    token = loginClient.getToken(companyLogin, sbmApiKey);
    //console.log('GOT TOKEN', token)
    return token;
}

const getSbmClient = (cb = null) => {
    SBM.client = getJSONRpcClient(cb);
    
    if (!SBM.client) {
        // This doesn't work
        return SBM.client = getJSONRpcClient(cb);
        // console.log('Token Expired: Getting new token.', );
    } else {
        // console.log('SBM CLIENT IS NOT EXPIRED', SBM.client);
        return SBM.client;
    }
}

const getAsyncSbmClient = ({refreshTokenCallback, stopAutoRefresh}) => {
    // console.log('Getting Async SMB RPC Client');
    return new Promise((resolve, reject) => {
        SBM.client = getJSONRpcClient();
        
        if (SBM.client) {
            resolve(SBM.client);
            // console.log('SBM client has been obtained: ', SBM.client);
            return;
        }
        let autoRefresh;
        if (!stopAutoRefresh) {
            autoRefresh = setInterval(
                () => {
                    const sbmClient = getJSONRpcClient(); 
                    refreshTokenCallback(sbmClient);
                    resolve(sbmClient);
                }, 3480000
            );
        } else {
            clearInterval(autoRefresh);
        }
    });
}

// LOGIN TO SBM
const getLoginClient = () => {
    return new JSONRpcClient({
        onerror: (error) => {
            alert(error);
            // console.log('Client Login Error @Calendar Actions');
        },
        onsuccess: (result) => {
            // alert(result);
            // console.log(result);
            // console.log('SBM Client Login Successful!');
        },
        url: 'https://user-api.simplybook.me/login',
    });
}

const getJSONRpcClient = (cb = null) => {
    token = getToken();
    // console.log('GOT TOKEN @ GET_JSON_RPC_CLIENT', token);
    const client = new JSONRpcClient({
        'headers': {
            'X-Company-Login': companyLogin,
            'X-Token': token
        },
        'onerror': (error) => {
            // alert('Error: '+ error + ' Message: ' + error.message + ' Code: ' + error.code + ' Token: ' + token);
            // console.log('%cGETTING CLIENT ERROR @SBM Calendar Actions','color: greenyellow');
            if (error.code === -32600 || error.code === '-32600'){
                // tokenExpired = true;
                // let newLoginClient = getLoginClient();
                token = getToken();
                SBM.client = new JSONRpcClient({
                    'headers': {
                        'X-Company-Login': companyLogin,
                        'X-Token': token
                    },
                    'onerror': (err) => {
                        // alert('Repeat Error: '+ error + ' Message: ' + error.message + ' was fired from repeat call to sbmLogin ' + 'Code: ' + error.code + ' Token: ' + token);
                        // console.log('%cGETTING CLIENT ERROR @SBM Calendar Actions','color: greenyellow');
                    },
                    'onsuccess': (result) => {
                        // console.log('successfully logged in this time');
                    },
                    'url': 'https://user-api.simplybook.me',
                });
                cb(SBM.client);
            }
        },
        'onsuccess': (result) => {
            // console.log('Did we get the JSONRPC Client?', JSON.stringify(result), result.code, result.message, result);
            if (result.code === -32600 ) {
                // console.log('FAILED TO GET JSON RPC CLIENT', result.message);
                token = getToken();
                SBM.client = new JSONRpcClient({
                    'headers': {
                        'X-Company-Login': companyLogin,
                        'X-Token': token
                    },
                    'onerror': (error) => {
                        // alert('Repeat Error: '+ error + ' Message: ' + error.message + ' was fired from repeat call to sbmLogin ' + 'Code: ' + error.code + ' Token: ' + token);
                        // console.log('%cGETTING CLIENT ERROR @SBM Calendar Actions','color: greenyellow');
                    },
                    'onsuccess': (resultAlt) => {
                        // console.log('successfully logged in this time');
                    },
                    'url': 'https://user-api.simplybook.me',
                });
                cb(SBM.client); 
            } else {
                // console.log('Successfully got JSON RPC CLIENT', result);
            }
        },
        'url': 'https://user-api.simplybook.me',
    });
    // console.log('CLIENT FROM JSON RPC CLIENT', client)
    return client;
}


export {getSbmClient as  default, getAsyncSbmClient};


// WEBPACK FOOTER //
// ./src/js/utils/getSbmClient.js